import styled from 'styled-components';

import ButtonBase from './ButtonBase';

export default styled(ButtonBase)`
  grid-template-columns: auto;
  column-gap: 0.6rem;
  color: ${(props) => props.theme.colors.grayScale.base};
`;
